<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card class="mb-3" title="Yeni Podcast Ekle">
                    <b-alert variant="warning" show class="mb-0">
                        <div class="alert-body mb-2">
                            <span><strong>Not:</strong> Eklenecek podcast bağlantı linki
                                benzersiz olmalıdır...</span>
                        </div>
                    </b-alert>
                    <b-button class="float-right" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                        to="/podcasts">
                        Podcast Listesi
                    </b-button>
                </b-card>
            </b-col>
        </b-row>
        <validation-observer ref="rules">
            <b-row>
                <b-col cols="12">
                    <b-card class="mb-3" title="Podcast Ekleme Formu">
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="Başlık" label-for="title">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="Başlık">
                                        <b-form-input id="title" v-model="title" placeholder="Başlık"
                                            :state="errors.length > 0 ? false : null"
                                            :class="title.length >= chars.title ? 'text-danger' : ''" />
                                        <small class="textarea-counter-value float-right"
                                            :class="title.length >= chars.title ? 'bg-danger' : ''">
                                            <span class="char-count">{{ title.length }}</span>
                                            /
                                            {{ chars.title }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Bağlantı Başlığı" label-for="linktTitle">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="Bağlantı Başlığı">
                                        <b-form-input id="linkTitle" v-model="linkTitle" placeholder="Bağlantı Başlığı"
                                            :state="errors.length > 0 ? false : null" :class="linkTitle.length >= chars.linkTitle ? 'text-danger' : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="linkTitle.length >= chars.linkTitle ? 'bg-danger' : ''
                                            ">
                                            <span class="char-count">{{ linkTitle.length }}</span>
                                            /
                                            {{ chars.linkTitle }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Bağlantı Başlığı" label-for="linktTitle">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="Bağlantı Başlığı">
                                        <b-form-input id="linkTitle" v-model="linkTitle" placeholder="Bağlantı Başlığı"
                                            :state="errors.length > 0 ? false : null" :class="linkTitle.length >= chars.linkTitle ? 'text-danger' : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="linkTitle.length >= chars.linkTitle ? 'bg-danger' : ''
                                            ">
                                            <span class="char-count">{{ linkTitle.length }}</span>
                                            /
                                            {{ chars.linkTitle }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <h5>Linkler</h5>
                                <hr />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Spotify" label-for="spotify">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="Spotify">
                                        <b-form-input id="spotify" v-model="links.spotify" placeholder="Spotify"
                                            :state="errors.length > 0 ? false : null" :class="links.spotify.length >= chars.links.spotify ? 'text-danger' : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="links.spotify.length >= chars.links.spotify ? 'bg-danger' : ''
                                            ">
                                            <span class="char-count">{{ links.spotify.length }}</span>
                                            /
                                            {{ chars.links.spotify }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="SoundCloud" label-for="SoundCloud">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="SoundCloud">
                                        <b-form-input id="SoundCloud" v-model="links.soundCloud"
                                            placeholder="SoundCloud" :state="errors.length > 0 ? false : null" :class="links.soundCloud.length >= chars.links.soundCloud ? 'text-danger' : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="links.soundCloud.length >= chars.links.soundCloud ? 'bg-danger' : ''
                                            ">
                                            <span class="char-count">{{ links.soundCloud.length }}</span>
                                            /
                                            {{ chars.links.soundCloud }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="ITunes" label-for="ICloud">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="ITunes">
                                        <b-form-input id="ICloud" v-model="links.iCloud" placeholder="ITunes"
                                            :state="errors.length > 0 ? false : null" :class="links.iCloud.length >= chars.links.iCloud ? 'text-danger' : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="links.iCloud.length >= chars.links.iCloud ? 'bg-danger' : ''
                                            ">
                                            <span class="char-count">{{ links.iCloud.length }}</span>
                                            /
                                            {{ chars.links.iCloud }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <hr />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="8">
                                <DragDropImage ref="refCardImage" dimensions="1440x720" title="Podcast Görseli" :imageUrl="null"
                                    :required="true"></DragDropImage>
                            </b-col>
                            <b-col md="4">
                                <b-form-group label="Görsel Başlığı (title)" label-for="imageTitle">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="Görsel Başlığı (title)">
                                        <b-form-textarea id="imageTitle" v-model="imageTitle"
                                            placeholder="Görsel Başlığı (title)" rows="3" class="char-textarea"
                                            :state="errors.length > 0 ? false : null" :class="imageTitle.length >= chars.imageTitle
                                                    ? 'text-danger'
                                                    : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="imageTitle.length >= chars.imageTitle ? 'bg-danger' : ''
                                            ">
                                            <span class="char-count">{{ imageTitle.length }}</span>
                                            /
                                            {{ chars.imageTitle }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group label="Görsel Açıklaması (alt text)" label-for="imageAltText">
                                    <validation-provider #default="{ errors }" :rules="{ required: true }"
                                        name="Görsel Açıklaması (alt text)">
                                        <b-form-textarea id="imageAltText" v-model="imageAltText"
                                            placeholder="Görsel Açıklaması (alt text)" rows="3" class="char-textarea"
                                            :state="errors.length > 0 ? false : null" :class="imageAltText.length >= chars.imageAltText
                                                    ? 'text-danger'
                                                    : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="imageAltText.length >= chars.imageAltText
                                                ? 'bg-danger'
                                                : ''
                                            ">
                                            <span class="char-count">{{ imageAltText.length }}</span>
                                            /
                                            {{ chars.imageAltText }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Bağlantı Linki" label-for="slug">
                                    <validation-provider #default="{ errors }" rules="required" name="Bağlantı Linki">
                                        <b-form-input id="slug" v-model="slug" placeholder="Bağlantı Linki"
                                            :state="errors.length > 0 || availability == false ? false : null"
                                            :class="slug.length >= chars.slug || availability == false ? 'text-danger' : ''" />
                                        <small class="textarea-counter-value float-right"
                                            :class="slug.length >= chars.slug ? 'bg-danger' : ''">
                                            <span class="char-count">{{ slug.length }}</span>
                                            /
                                            {{ chars.slug }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                    <div v-if="availability == false">
                                        <p class="text-danger"><small>Podcast linki benzersiz olmalıdır.</small></p>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="12">
                                <b-form-group label="Meta Açıklaması" label-for="metaTitle">
                                    <validation-provider #default="{ errors }" :rules="{ required: true, min: 30 }"
                                        name="Meta Açıklaması">
                                        <b-form-textarea id="metaTitle" v-model="metaDescription"
                                            placeholder="Meta Açıklaması" rows="3" class="char-textarea"
                                            :state="errors.length > 0 ? false : null" :class="metaDescription.length >= chars.metaDescription
                                                    ? 'text-danger'
                                                    : ''
                                                " />
                                        <small class="textarea-counter-value float-right" :class="metaDescription.length >= chars.metaDescription
                                                ? 'bg-danger'
                                                : ''
                                            ">
                                            <span class="char-count">{{
                                                metaDescription.length
                                                }}</span>
                                            /
                                            {{ chars.metaDescription }}
                                        </small>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" class="mt-5"></b-col>
                            <b-col md="6" class="mt-5">
                                <div>
                                    <b-button class="float-right mt-2" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                        variant="outline-success" @click="postConfirmText(false, false)">
                                        <b-spinner v-if="spinner === true && isDraft === false" small />
                                        {{
                                            spinner === true && isDraft === false
                                                ? "Yayınlanıyor"
                                                : "Yayınla"
                                        }}
                                    </b-button>
                                </div>
                                <div>
                                    <b-button class="float-right mt-2 mr-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                        variant="outline-warning" @click="postConfirmText(true, false)">
                                        <b-spinner v-if="spinner == true && isDraft == true" small />
                                        {{
                                            spinner == true && isDraft == true
                                                ? "Taslağa Kaydediliyor"
                                                : "Taslağa Kaydet"
                                        }}
                                    </b-button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </validation-observer>
    </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
    BImg,
    BRow,
    BCol,
    BTime,
    BCard,
    BCardText,
    BButton,
    BForm,
    BMedia,
    BAlert,
    BSpinner,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    BLink,
} from "bootstrap-vue";
import {
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
} from "@validations";

import settings from '../../../settings';
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
    components: {
        DragDropImage,
        BImg,
        BRow,
        BCol,
        BTime,
        BLink,
        BCard,
        BCardText,
        BButton,
        BForm,
        BSpinner,
        BAlert,
        BFormGroup,
        BFormInput,
        BInputGroup,
        BFormTextarea,
        BMedia,
        BMediaAside,
        BMediaBody,
        BFormFile,
        BFormDatepicker,
        BFormCheckbox,
        vSelect,
        ValidationProvider,
        ValidationObserver,
        required,
        email,
        confirmed,
        url,
        between,
        alpha,
        integer,
        password,
        min,
        digits,
        alphaDash,
        length,
    },
    directives: {
        Ripple,
    },
    mixins: [heightTransition],
    data() {
        return {
            id: "",
            slug: "",
            title: "",
            image: null,
            linkTitle: "",
            imageTitle: "",
            imageAltText: "",
            featuredImage: require("@/assets/images/placeholder/1920x1080.jpg"),
            metaDescription: "",
            spinner: false,
            availability: true,
            slugParam: this.$route.params.slugParam,
            targetLocale: this.$route.query.targetLocale,
            links: {
                spotify: "",
                soundCloud: "",
                iCloud: ""
            },
            chars: {
                slug: 255,
                title: 255,
                linkTitle: 55,
                imageTitle: 60,
                imageAltText: 140,
                metaDescription: 160,
                links: {
                    spotify: 500,
                    soundCloud: 500,
                    iCloud: 500
                }
            },
        };
    },
    watch: {
        title(newTitle, oldTitle) {
            this.slug = newTitle;
            this.linkTitle = newTitle;
            this.imageTitle = newTitle;
            this.imageAltText = newTitle;
        },
        slug(newSlug, oldSlug) {
            this.slug = this.slugify(newSlug)
            this.slugAvailability(this.slug);
        },
    },
    methods: {
        slugify(text, ampersand = "and") {
            const a = "àáäâèéëêıìíïîòóöôùúüûñçßÿỳýœæŕśşńṕẃǵğǹḿǘẍźḧ";
            const b = "aaaaeeeeiiiiioooouuuuncsyyyoarssnpwggnmuxzh";
            const p = new RegExp(a.split("").join("|"), "g");
            return text
                .toString()
                .toLowerCase()
                .replace(/[\s_]+/g, "-")
                .replace(p, (c) => b.charAt(a.indexOf(c)))
                .replace(/&/g, `-${ampersand}-`)
                .replace(/[^\w-]+/g, "")
                .replace(/--+/g, "-")
                .replace(/^-+|-+$/g, "");
        },
        slugAvailability(slug) {
            let formData = new FormData();
            formData.append("id", null);
            formData.append("slug", slug);
            endpoints
                .postPodcastsAvailability(formData, this.targetLocale, () => { })
                .then((data) => {
                    this.availability = data.response.availability
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        postConfirmText(isDraft, preview) {
            this.isDraft = isDraft;
            this.$swal({
                title: "Kayıt?",
                text: "Yeni eğitmeni kaydetmek istediğinize emin misiniz?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Vazgeç!",
                confirmButtonText: "Kaydet!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.postSubmit(preview);
                }
            });
        },
        postSubmit(preview) {
            if (this.availability) {
                this.$refs.rules.validate().then((success) => {
                    if (success) {
                        this.spinner = true;
                        let formData = new FormData();
                        formData.append("id", this.id);
                        formData.append("slug", this.slug);
                        formData.append("title", this.title);
                        formData.append("image", this.$refs.refCardImage.image);
                        formData.append("links", JSON.stringify(this.links));
                        formData.append("linkTitle", this.linkTitle);
                        formData.append("imageTitle", this.imageTitle);
                        formData.append("imageAltText", this.imageAltText);
                        formData.append("metaDescription", this.metaDescription);
                        endpoints
                            .postPodcastsTranslation(formData, this.targetLocale, () => { })
                            .then((data) => {
                                this.spinner = false;
                                if (data.status) {
                                    if (preview == true) {
                                        // window.open(`${settings.uiBaseUrl}/educators/preview/${this.slug}?hl=${this.targetLocale}`, '_blank');
                                        window.open(`${settings.uiBaseUrl}/podcasts?hl=${this.targetLocale}`, '_blank');
                                    }
                                    this.$swal({
                                        icon: "success",
                                        title: "Kayıt başarılı!",
                                        text: "Yeni podcast eklendi.",
                                        customClass: {
                                            confirmButton: "btn btn-success",
                                        },
                                    }).then((result) => {
                                        if (result.value) {
                                            this.$router.push({
                                                path: `/podcasts`,
                                            });
                                        }
                                    });
                                } else {
                                    this.$swal({
                                        title: 'Hata!',
                                        text: 'Podcast bağlantı linki benzersiz değil!',
                                        icon: 'error',
                                        confirmButtonText: "Tamam",
                                        customClass: {
                                            confirmButton: 'btn btn-primary',
                                        },
                                    }).then((result) => {
                                        if (result.value) {

                                        }
                                    });
                                }
                            })
                            .catch((err) => {
                                this.spinner = false;
                                console.log(err);
                            });
                    }
                });
            } else {
                this.$swal({
                    title: 'Hata!',
                    text: 'Podcast bağlantı linki benzersiz değil!',
                    icon: 'error',
                    confirmButtonText: "Tamam",
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                }).then((result) => {
                    if (result.value) {

                    }
                });
            }
        },
    },
    created() { },
    destroyed() { },
    mounted() {
        setTimeout(() => {
            endpoints
                .getPodcastsBySlug(this.slugParam, this.$i18n.locale, () => { })
                .then((data) => {
                    this.id = data.response.id;
                })
                .catch((err) => {
                    console.log(err);
                });
        }, 200);
    },
    setup() { },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>